import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { SystemService } from 'src/app/service/system.service';
import { AdmService } from 'src/app/service/adm.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-update-marital-status',
  templateUrl: './update-marital-status.component.html',
  styleUrls: ['./update-marital-status.component.scss']
})
export class UpdateMaritalStatusComponent implements OnInit {

  creating: boolean = false;
  showLoader: boolean = false;
  disabled = false;
  ShowFilter = true;
  limitSelection = false;
  updating: boolean = false;
  martialStatusId: any;

  updateMartialStatus = new FormGroup({

    martialNameAr: new FormControl('', [
      Validators.required,
    ]),
    martialNameEn: new FormControl('', [
      Validators.required,
    ]),
    orderId: new FormControl('', [
      Validators.required,
    ]),
  });

  constructor(public translateService:TranslateService,public admService:AdmService,public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router, public systemService: SystemService, private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.martialStatusId = params['martialStatus'] || "";

        if (this.martialStatusId != "") {
          this.showLoader = true;
          // Get Role
          this.getMartialStatus();

        } else {
          console.log("no martial Status");
          this.router.navigate(['/admission/app-marital-status']);
        }
      });
  }
  editCountrySubmit() {
    if (this.updateMartialStatus.valid) {
      let countryNameAr = this.updateMartialStatus.controls.martialNameAr?.value;
      let countryNameEn = this.updateMartialStatus.controls.martialNameEn?.value;
      let orderNo=this.updateMartialStatus.controls.orderId?.value;
      this.updateMartial(countryNameAr, countryNameEn,orderNo);

    }
    else {
      this.updateMartialStatus.markAllAsTouched();
      this.updateMartialStatus.markAsDirty();
    }
  }

  updateMartial(countryNameAr: string, countryNameEn: string,orderNo:number) {
    this.updating = true;
    this.admService.updateMartialStatus(this.martialStatusId, countryNameAr, countryNameEn,orderNo).subscribe(
      data => {
        this.router.navigate(['/admission/app-marital-status']);
        this.toastr.success(this.translateService.instant('UPDATED_SUCCESSFULLY'));
      },
      error => {
        this.updating = false
        this.toastr.error(this.translateService.instant('CAN_NOT_UPDATE'));
      },
      () => this.updating = false
    );
  }

  getMartialStatus() {
    this.showLoader = true;
    this.admService.getMartialStatus(this.martialStatusId)
      .subscribe(
        data => {
          this.updateMartialStatus.controls.martialNameAr.setValue(data.maritalStatusNameAr);
          this.updateMartialStatus.controls.martialNameEn.setValue(data.maritalStatusNameEn)
          this.updateMartialStatus.controls.orderId.setValue(data.orderNo);
        },
        error => {          
          this.toastr.error(this.translateService.instant('CAN_NOT_GET_MARTIAL_STATUS'));
          
        },
        () => this.showLoader = false
      );
  }

 

  updateMartialSubmit() {
    if (this.updateMartialStatus.valid) {
      let countryNameAr = this.updateMartialStatus.controls.martialNameAr?.value;
      let countryNameEn = this.updateMartialStatus.controls.martialNameEn?.value;
      let orderId=this.updateMartialStatus.controls.orderId?.value;
      this.updateMartial(countryNameAr, countryNameEn,orderId);

    }
    else {
      this.updateMartialStatus.markAllAsTouched();
      this.updateMartialStatus.markAsDirty();
    }
  }

  updateMartialChange() {

    // this

  }

}
